<template>
  <div class="home">
    <img src="img/loader_animhead.gif">
    <HelloWorld msg="Retrouvez très prochainement une nouvelle façon d'animer vos évènements." titleBalise="h3"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
<style scoped>
.home img{
  width: 20%;
}
.home{
  padding:0 20px;
  margin: auto;
}

@media (max-width: 1020px){
  .home img{
    width: 50%;
  }
}
</style>
